<div class="outer">
  <div class="inner">
    <div class="loader"></div>
    <div>Gegevens worden opgehaald.<br/>Even geduld alsjeblieft.</div>
  </div>
</div>
